export const IDENTITIES = new Set(["SSN"]);